import { IMAGE_ATTRIBUTE } from "@circle-react-shared/uikit/EditorAttachmentModal/constants";
import { EditorAttachmentModalComponent } from "@circle-react-shared/uikit/EditorAttachmentModal/EditorAttachmentModalComponent";
import {
  fetchRemoteImageAsFile,
  remoteImageFetchErrorMessage,
} from "@circle-react-shared/uikit/EditorAttachmentModal/fetchRemoteImageAsFile";
import type { Editor } from "@tiptap/core";
import { useCallback } from "react";

import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

interface ImageModalComponentProps {
  editor: Editor;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  range: { from: number; to: number };
}

export const ImageModalComponent = ({
  editor,
  onOpenChange,
  open,
  range,
}: ImageModalComponentProps) => {
  const toast = useToast();

  const insertFile = useCallback(
    (file: File) => {
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .insertContent({ type: "file-loader", attrs: { file } })
        .run();
    },
    [editor, range],
  );

  const onSubmitUrl = useCallback(
    async (url: string) => {
      const result = await fetchRemoteImageAsFile(url);
      if (!result.ok) {
        toast.error(remoteImageFetchErrorMessage(result.error));
        return;
      }
      insertFile(result.file);
    },
    [insertFile, toast],
  );

  return (
    <EditorAttachmentModalComponent
      attribute={IMAGE_ATTRIBUTE}
      subtype="image"
      insertFile={insertFile}
      onSubmitUrl={onSubmitUrl}
      open={open}
      onOpenChange={onOpenChange}
    />
  );
};
